import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconColumnWideHalfAdd: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconColumnWideHalfAdd"><Path d="M2 4V20H12V18.5H3.5V12.75H22V4H2Z" fill="currentColor"/><Path d="M19.5 15.5H18V18.5H15V20H18V23H19.5V20H22.5V18.5H19.5V15.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconColumnWideHalfAdd;
